<template>
    <section class="sub_page_con wrap_1120">
        <div class="bread_crumbs">
            <router-link to="/" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></router-link>
            <span class="icon_wrap"><img src="img/part_icon.png" alt="소개" /></span>
            <span class="faq_list_title">소개</span>
            <span class="icon_wrap"><img src="img/part_icon.png" alt="자주묻는 질문(FAQ)" /></span>
            <span class="faq_list_title">자주묻는 질문(FAQ)</span>
        </div>
        <div style="display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 10px">
            <div class="sub_con_tit">FAQ</div>

            <div class="btn_wrap _default _board_type" v-if="state.hasAuth" style="justify-content: flex-end">
                <router-link class="common_btn w_130" :to="{ name: 'FaqWrite' }">글쓰기</router-link>
            </div>
        </div>

        <div class="search_wrap">
            <input type="text" v-model="state.searchText" @keyup.enter="getSearch" placeholder="검색어를 입력하세요." />
            <button class="search_btn icon_wrap" @click="getSearch"><img src="img/search_btn.png" alt="" /></button>
        </div>
        <div class="list_table con_board sub_page_con_view faqList">
            <ul>
                <!-- <li class="tbody_li active"> -->
                <li class="tbody_li" v-for="(item, index) in state.list" :key="item.idx" v-if="state.list.length > 0">
                    <div class="tr_div con_tit">
                        <div class="tb_no" v-show="!state.isMobile">{{ (state.page - 1) * state.size + (index + 1) }}</div>
                        <div class="tb_subject">
                            <router-link :to="{ name: 'FaqView', params: { id: item.idx } }" class="elips_1 block">
                                {{ item.title }}
                            </router-link>
                        </div>
                    </div>
                </li>
                <li v-else class="tbody_li no_data">
                    <div class="tr_div">
                        <div class="tb_subject" style="text-align: center; width: 100%">등록된 게시물이 없습니다.</div>
                    </div>
                </li>
            </ul>
        </div>
        <PageBtn
            v-if="state.list.length !== 0"
            :currentPage="state.page"
            :totalLength="state.totalLength"
            :perPage="state.size"
            @onPaging="handlePageChange"
        ></PageBtn>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        reactive,
        globalStore,
        onMounted,
        watch,
        router,
        apiService,
        types,
        CommonUtils,
        userStore,
        PageBtn,
        ModalDefault,
        onBeforeMount,
        getMessageByCode,
    } from "@/BaseComponent";

    export default {
        components: { PageBtn, ModalDefault },
        setup() {
            const user = userStore();
            const global = globalStore();
            const state = reactive({
                tab: 0 as number,

                page: 1 as number,
                size: 10 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                list: [] as Array<types.ResFaqVOForApi>,

                searchType: "" as string,
                searchText: "" as string,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                hasAuth: false,

                isMobile: false,
            });

            onBeforeMount(() => {
                if (user.isLogin() && user.userInfo.gubun === 1) state.hasAuth = true;
            });

            onMounted(() => {
                getList();
                state.isMobile = window.innerWidth < 768;
            });

            const getList = async () => {
                const param: types.ReqCommonPaging = {
                    page: state.page,
                    size: state.size,
                    searchType: null,
                    searchText: state.searchText,
                };
                const res = await apiService.faq.list(param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;

                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };
            const getSearch = () => {
                state.page = 1;
                getList();
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const closeModal = () => {
                state.isShowModal = false;
                getList();
            };

            const callBackModal = async (param: any) => {
                getList();
            };

            return { state, router, handlePageChange, CommonUtils, getSearch, closeModal, callBackModal };
        },
    };
</script>
<style scoped>
    .faq_list_title {
        color: #6d6d6d;
        font-size: 14px;
        font-weight: 500;
    }
    .elips_1 .block {
        width: 100%;
        display: inline-block;
    }
</style>
